export default __webpack_public_path__ + "a3e13f0ccc009f27e563f52dde041e57.png";